<template>
  <v-dialog
    :value="value"
    max-width="480"
    persistent
    @input="$emit('input', $event)"
  >
    <v-card v-if="item">
      <v-card-title class="font-weight-medium secondary--text primary">
        <v-icon small color="secondary" class="mr-2">mdi-content-duplicate</v-icon>
        Create New Entry
        <v-spacer />
        <v-btn small icon @click="close">
          <v-icon small color="secondary">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />

      <v-card-text class="pt-5">
       <!--
       <div class="caption grey--text mb-4">
          Use this when the same session is taken for a second course. The copy
          keeps the date, slot, timings, faculty and webinar link below — only
          the course code changes, and it gets its own attendance.
        </div>-->

        <v-form ref="duplicateForm" lazy-validation>
          <v-text-field
            v-model="courseCode"
            label="Course Code *"
            outlined
            dense
            hide-details="auto"
            autofocus
            :error-messages="errorMessage"
            @input="errorMessage = ''"
            @keyup.enter="submit"
          />
        </v-form>

        <v-simple-table dense class="mt-4">
          <tbody>
            <tr v-for="row in summaryRows" :key="row.label">
              <td class="caption grey--text">{{ row.label }}</td>
              <td class="caption">{{ row.value || "—" }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>

      <v-divider />
      <v-card-actions class="px-4 pb-4 pt-3">
        <v-spacer />
        <v-btn class="primary white--text" :loading="saving" @click="submit">
          Create
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DuplicateEntryDialog",
  props: {
    value: { type: Boolean, default: false },
    item: { type: Object, default: null },
  },
  data() {
    return {
      courseCode: "",
      errorMessage: "",
      saving: false,
    };
  },
  computed: {
    summaryRows() {
      const item = this.item || {};
      return [
        { label: "Existing Course Code", value: item.course_code },
        { label: "Programme", value: item.program_code },
        { label: "Semester", value: item.semester_number },
        { label: "Class ID", value: item.class_id },
        { label: "Webinar Date", value: this.formatDate(item.webinar_date) },
        { label: "Slot", value: item.slot ? String(item.slot).toUpperCase() : "" },
        {
          label: "Timing",
          value:
            item.from_time || item.to_time
              ? `${this.formatTime(item.from_time)} – ${this.formatTime(item.to_time)}`
              : "",
        },
        { label: "Faculty", value: item.faculty_name },
        { label: "Webinar Link", value: item.webinar_link },
      ];
    },
  },
  watch: {
    value(open) {
      if (open) {
        this.courseCode = "";
        this.errorMessage = "";
      }
    },
  },
  methods: {
    async submit() {
      const code = String(this.courseCode || "").trim();
      if (!code) {
        this.errorMessage = "Course code is required";
        return;
      }
      this.saving = true;
      try {
        await this.$axios.post(`/scheduler/entries/${this.item.id}/duplicate`, {
          course_code: code,
        });
        this.$store.commit("showSnackbar", {
          message: "Entry duplicated",
          color: "success",
        });
        this.$emit("saved");
        this.close();
      } catch (e) {
        const msg =
          e.response?.data?.error ||
          e.response?.data?.message ||
          "Duplicate failed";
        this.errorMessage = typeof msg === "string" ? msg : "Duplicate failed";
        this.$store.commit("showSnackbar", {
          message: this.errorMessage,
          color: "error",
        });
      } finally {
        this.saving = false;
      }
    },

    formatDate(dateStr) {
      if (!dateStr) return "";
      const [y, m, d] = String(dateStr).split("-");
      return `${d}-${m}-${y}`;
    },

    formatTime(timeStr) {
      if (!timeStr) return "—";
      return String(timeStr).split(":").slice(0, 2).join(":");
    },

    close() {
      this.$emit("input", false);
    },
  },
};
</script>
